import { type FC } from 'react';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { Box, Typography } from '@mui/material';

/**
 * Empty state for the labels manager (GDN-2019) — shown when the practice has
 * not created any groups or labels yet.
 */
export const EmptyLabelsState: FC = () => (
  <Box sx={{ textAlign: 'center', py: 6, color: 'text.secondary' }}>
    <Box
      sx={{
        width: 88,
        height: 88,
        mx: 'auto',
        mb: 2,
        borderRadius: '50%',
        border: '2px dashed',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LabelOutlinedIcon sx={{ fontSize: 40, color: 'text.disabled' }} />
    </Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
      No labels yet
    </Typography>
    <Typography variant="body2" sx={{ mt: 0.5, maxWidth: 360, mx: 'auto' }}>
      Create a group (e.g. “Spravato Rooms”) or a standalone label to start
      organizing your calendar into columns.
    </Typography>
  </Box>
);
